// ✅ Pull runtime config or fall back to environment or /api
export const getConfig = () => {
  return window.__RUNTIME_CONFIG__ || {
    API_URL: process.env.REACT_APP_API_URL || '/api',   // 👈 default now /api
    ENVIRONMENT: process.env.REACT_APP_ENV || 'development'
  };
};

export const getConfigValue = (key, defaultValue) => {
  const config = getConfig();
  return config[key] !== undefined && config[key] !== `PLACEHOLDER_${key}`
    ? config[key]
    : defaultValue;
};

// ✅ All API calls will now go to /api (handled by Nginx)
export const API_URL = getConfigValue('API_URL', '/api');
export const ENVIRONMENT = getConfigValue('ENVIRONMENT', 'development');
